import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "onChange", "value", "disabled", "readOnly", "hasError", "hint", "legend", "name"];
import React, { forwardRef } from 'react';
import { isString } from 'ramda-extension';
import getEventHandlersFromProps from '../utils/getEventHandlersFromProps';
import RadioGroup from '../RadioGroup';
import FormGroup from '../FormGroup';
var RadioGroupField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      value = _ref.value,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      hasError = _ref.hasError,
      hint = _ref.hint,
      legend = _ref.legend,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormGroup, _extends({
    ref: ref,
    legend: legend,
    hint: hint,
    disabled: disabled,
    readOnly: readOnly,
    hasError: hasError
  }, rest), /*#__PURE__*/React.createElement(RadioGroup, _extends({
    "aria-label": isString(legend) ? legend : null,
    onChange: onChange,
    value: value,
    disabled: disabled,
    readOnly: readOnly,
    hasError: hasError,
    name: name
  }, getEventHandlersFromProps(rest)), children));
});
RadioGroupField.displayName = 'RadioGroupField';
export default RadioGroupField;